import { ChevronDownIcon } from 'lucide-react'
import type * as React from 'react'

import { cn } from '@/lib/utils'

function NativeSelect({
	className,
	size = 'default',
	...props
}: Omit<React.ComponentProps<'select'>, 'size'> & { size?: 'sm' | 'default' }) {
	return (
		<div
			className="group/native-select relative w-full has-[select:disabled]:opacity-50"
			data-slot="native-select-wrapper"
		>
			<select
				data-slot="native-select"
				data-size={size}
				className={cn(
					'border-input placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 dark:hover:bg-input/50 h-9 w-full min-w-0 appearance-none rounded-md border bg-transparent px-3 py-2 pr-9 text-sm shadow-xs transition-[color,box-shadow] outline-none disabled:pointer-events-none disabled:cursor-not-allowed data-[size=sm]:h-8 data-[size=sm]:py-1',
					'focus:outline-none focus:ring-0',
					/* focus-visible styles intentionally removed to avoid persistent outline */
					'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
					className,
				)}
				{...props}
			/>
			<ChevronDownIcon
				className="text-kaefer-dark-grey pointer-events-none absolute top-1/2 right-2 size-4 -translate-y-1/2 opacity-50 select-none"
				aria-hidden="true"
				data-slot="native-select-icon"
			/>
		</div>
	)
}

function NativeSelectOption({ ...props }: React.ComponentProps<'option'>) {
	return <option data-slot="native-select-option" {...props} />
}

function NativeSelectOptGroup({
	className,
	...props
}: React.ComponentProps<'optgroup'>) {
	return (
		<optgroup
			data-slot="native-select-optgroup"
			className={cn(className)}
			{...props}
		/>
	)
}

export { NativeSelect, NativeSelectOptGroup, NativeSelectOption }
